export default __webpack_public_path__ + "static/media/Batdick.31a5b077.png";